import { Box } from '@mui/material';
import { FC } from 'react';

interface OtherCountryIconProps {
  countryName: string;
  size?: number;
}

const OtherCountryIcon: FC<OtherCountryIconProps> = ({ countryName, size = 24 }) => {
  const getCountryInitial = (name: string) => {
    if (!name) return '?';
    return name.charAt(0).toUpperCase();
  };

  const getCountryColor = (name: string) => {
    if (!name) return '#E0E0E0';

    // Generate a consistent color based on country name
    const colors = [
      '#FF6B6B', '#4ECDC4', '#45B7D1', '#96CEB4', '#FFEAA7',
      '#DDA0DD', '#98D8C8', '#F7DC6F', '#BB8FCE', '#85C1E9',
      '#F8C471', '#82E0AA', '#F1948A', '#85C1E9', '#D7BDE2'
    ];

    const index = name.charCodeAt(0) % colors.length;
    return colors[index];
  };

  return (
    <Box
      sx={{
        width: size,
        height: size,
        borderRadius: '50%',
        background: getCountryColor(countryName),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: '2px solid #FFFFFF',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        color: '#FFFFFF',
        fontWeight: 'bold',
        fontSize: size * 0.4,
        textShadow: '0 1px 2px rgba(0,0,0,0.3)'
      }}
    >
      {getCountryInitial(countryName)}
    </Box>
  );
};

export default OtherCountryIcon; 